// 最近转发组件

import React, { useEffect, useMemo, useRef } from "react";

import { IItemData, ChangeParams } from "./common.typing";
import listChangeHoc from "./listChangeHOC";
import locale, { isEN } from "../../_util/locale";
import SelectedImg from "./assets/imgs/selected.png";
import { DEFAULT_USER_IMG } from "./utils";

export interface RecentForwardProps {
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    recentForwardList?: IItemData[];
    onChangeHoc: (params: ChangeParams) => void;
    track: (eventName: string, eventData?: any) => void;
    title?: string;
}

const RecentForward: React.FC<RecentForwardProps> = ({
    currentList,
    setCurrentList,
    recentForwardList,
    onChangeHoc,
    track,
    title,
}) => {
    const onChange = (id: any, checked: boolean, index: number) => {
        if (checked) {
            track("Click_Chat_Element", {
                pageName: "PSelect_001",
                chat_name: title,
                OrderNumber: index + 1,
                $element_name: "PSelect_002",
            });
        }
        onChangeHoc({
            value: id,
            checked,
            list: recentForwardList || [],
            currentList,
            setCurrentList,
        });
    };

    const getName = (item: IItemData): string => {
        const { i18n_name, name } = item;
        const { en_us, zh_cn } = i18n_name || {};
        return (isEN() ? en_us : zh_cn) || name;
    };

    if (!recentForwardList || recentForwardList.length === 0) {
        return null;
    }

    return (
        <div className="recentForwardBox">
            <p className="recentForwardTitle">
                <span>{locale("recent_forward_title")}</span>
            </p>
            <div className="recentForwardList">
                {recentForwardList?.map((v, index) => {
                    const isSelected = currentList.some(
                        item => item.id === v.id
                    );
                    return (
                        <div
                            className="recentForwardItem"
                            key={v.id}
                            onClick={() => onChange(v.id, !isSelected, index)}
                        >
                            <img
                                className={`avatar ${
                                    isSelected ? "selected" : ""
                                }`}
                                src={v.pic || DEFAULT_USER_IMG}
                            />
                            <span className="name">{getName(v)}</span>
                            {isSelected && (
                                <img
                                    className="selectedIcon"
                                    src={SelectedImg}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default listChangeHoc(RecentForward);
